import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import s from './LargeSophisticatedTooltipHeading.scss';
var LargeSophisticatedTooltipHeading = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("span", __assign({ className: c(s['root'], className) }, rest), children));
};
LargeSophisticatedTooltipHeading.displayName =
    'LargeSophisticatedTooltipHeading';
export default LargeSophisticatedTooltipHeading;
//# sourceMappingURL=LargeSophisticatedTooltipHeading.js.map